import { ref, watch, onMounted } from 'vue';

/**
 * Dark mode composable with localStorage persistence
 * Manages theme state and applies dark class to document
 */
export function useDarkMode() {
  const isDark = ref(false);

  const setDarkMode = (value) => {
    isDark.value = value;
  };

  const toggleDark = () => {
    isDark.value = !isDark.value;
  };

  // Watch for changes and update DOM + localStorage
  watch(isDark, (newValue) => {
    if (newValue) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, { immediate: false });

  // Initialize from localStorage or system preference
  onMounted(() => {
    const savedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

    if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
      isDark.value = true;
      document.documentElement.classList.add('dark');
    } else {
      isDark.value = false;
      document.documentElement.classList.remove('dark');
    }
  });

  return {
    isDark,
    toggleDark,
    setDarkMode
  };
}
